import {
  initBridge,
  getChildClient,
  getIsInIframe,
  resetBridgeForTesting,
  type InitBridgeOptions,
  type NativeEmbedChildClient,
} from './bridge';
import {
  initCommandListeners,
  initStateFromUrl,
  requestResize,
  resetStateForTesting,
} from './state';

export type InitNativeEmbedEditorPluginOptions = InitBridgeOptions;

export function initNativeEmbedEditorPlugin(
  options?: InitNativeEmbedEditorPluginOptions
): NativeEmbedChildClient | null {
  initStateFromUrl();
  const client = initBridge(options);
  initCommandListeners();
  return client;
}

export function resetForTesting(): void {
  resetStateForTesting();
  resetBridgeForTesting();
}

export { getChildClient, getIsInIframe, requestResize, type NativeEmbedChildClient };
